import $ from 'jquery';

$(document).ready(() => {
    // gestion des rgp sur le consentement
    let obj = $('.accept-this-1 input:checkbox');
    obj.attr("checked","checked");
    //console.log(obj);
    $('.menu-830 select').change(function(){
        if($(this).val() !='Candidature spontanée') {
            //console.log(obj + 'add')
            obj.attr("checked");
        }
        else {
            //console.log(obj + 'remove')
            obj.removeAttr("checked");
        }
    });

    // remove some class ton plugin cf7-smart grid
    //$('.cf7-smart-grid').removeClass('cf7-smart-grid');
})

